import React from 'react';

function TodoItem({ todo, index, toggleComplete, deleteTodo }) {
  return (
    <div style={{ textDecoration: todo.completed ? 'line-through' : '' }}>
      {todo.text}
      <button onClick={() => toggleComplete(index)}>✔</button>
      <button onClick={() => deleteTodo(index)}>✖</button>
    </div>
  );
}

export default TodoItem;